import { InObjectPropertyHelperBase } from './InObjectPropertyHelperBase';
export class InSymbolObjectPropertyHelper extends InObjectPropertyHelperBase {
    getObject(sb) {
        return sb.helpers.getSymbolObject;
    }
}

//# sourceMappingURL=InSymbolObjectPropertyHelper.js.map
